import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=236c3a9a&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=236c3a9a&prod&scoped=true&lang=css"
import style1 from "./Notification.vue?vue&type=style&index=1&id=236c3a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c3a9a",
  null
  
)

export default component.exports